// App.jsx

import React, { useState, useEffect } from 'react';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import Portfolio from './components/Portfolio';
import Team from './components/Team';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

/* WHATSAPP ICON */
import { FaWhatsapp } from 'react-icons/fa';

import './styles.css';

function App() {

  const [theme, setTheme] = useState('light');

  /* DARK & LIGHT MODE */

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) =>
      prevTheme === 'light' ? 'dark' : 'light'
    );
  };

  return (
    <div className="app-wrapper">

      {/* NAVBAR */}
      <Navbar
        theme={theme}
        toggleTheme={toggleTheme}
      />

      {/* MAIN CONTENT */}
      <main>

        <Hero />

        <About />

        <Services />

        <WhyChooseUs />

        <Portfolio />

        <Team />

        <Testimonials />

        <Contact />

      </main>

      {/* WHATSAPP FLOAT BUTTON */}

 <a
  href="https://wa.me/94711922350"
  className="whatsapp-float"
  target="_blank"
  rel="noreferrer"
>
  <FaWhatsapp />
</a>

      {/* FOOTER */}
      <Footer />

    </div>
  );
}

export default App;